import React, { Component } from 'react';
import ReactTestUtils
	from 'react-dom/test-utils';
import $
	from 'jquery';
import PropTypes
	from 'prop-types';
import 'antd/dist/antd.css';
import CreateForm
	from './../forms/CreateForm';
import ProfilesActions
	from './../includes/ProfilesActions';
import './../assets/css/MenuPauPrincipal.css';
import update
	from 'immutability-helper';
import { eventClickPauActions } from './../assets/js/MenuPauPrincipal';
import { pictosPanel } from './../assets/img/panel';
import AccesibilityActions
	from './AccesibilityActions';
import { instanceOf } from 'prop-types';
import {
	withCookies,
	Cookies
} from 'react-cookie';

class CreateSection extends Component {

	static propTypes = {
		cookies : instanceOf( Cookies ).isRequired
	};

	constructor( props ) {

		super( props );

		const {
				  settings,
				  globals,
				  shows
			  } = props;

		this.state = {
			settings,
			globals,
			shows
		};

		/**
		 * Elementos de Selección Única
		 */
		this.elementsUnique = {
			perfiles : [
				{
					"custom" : "pauPerfilPorDefecto"
				},
				{
					"visual-diversity" : "pauPerilfDivVisual"
				},
				{
					"auditive-diversity" : "pauPerilfDivAudi"
				},
				{
					"cognitive-diversity" : "pauPerilfDivCogni"
				},
				{
					"custom" : "pauPerilfPer"
				}
			],
			fuentes  : [
				{
					"readable" : "pauFuentesLegible"
				},
				{
					"dyslexia" : "pauFuentesDislexia"
				}
			],
			visuals  : [
				{
					"blackwhite" : "pau_react_blanco_negro"
				},
				{
					"invert-colors" : "pau_react_invertir_colores"
				}
			]
		};

	}

	callbackUniqueValue = ( checked, type, elements, keyValue ) => {

		let valCheck    = "",
			{ cookies } = this.props,
			setti       = cookies.get( "settings" ),
			{ value }   = setti[ keyValue ];

		if ( checked ) {

			elements.forEach( elem => {

				let key   = Object.keys( elem )[ 0 ],
					$elem = $( `#${elem[ key ]}` );

				if ( value === key ) {
					$elem.trigger( "click" );
				}

			} );

			valCheck = type;

		}

		let new_value = {};

		new_value[ keyValue ] = {
			value : { $set : valCheck }
		};

		switch ( keyValue ) {

			case "visual_colors" :
				AccesibilityActions.visual( type, checked );
				break;

			case "font_dislexia_legible" :
				AccesibilityActions.fuentes( type, checked );
				break;

			case "perfil_defecto" :

				cookies.remove( "settings", { path : "/" } );
				cookies.set( "settings", update( setti, new_value ), { path : "/" } );
				this.setState( update( this.state, {
					settings : new_value
				} ) );

				if ( checked ) ProfilesActions.selection( type );

				break;

		}

		if ( keyValue === "perfil_defecto" ) return;

		let noPersonalizado = parseInt( cookies.get( "noPersonalizado" ), 10 );

		if ( !noPersonalizado && setti.perfil_defecto.value !== "custom" ) {

			let $profileCustom = $( "#pauPerilfPer" );

			$profileCustom.trigger( "click" );

		}

		cookies.remove( "settings", { path : "/" } );
		cookies.set( "settings", update( setti, new_value ), { path : "/" } );

		this.setState( update( this.state, {
			settings : new_value
		} ) );

	};

	getSections( settings ) {

		const { globals, shows } = this.props;
		const pictos = pictosPanel( globals.pau_PluginDirUrl );
		const d = document;

		const t = window.reactTranslate;

		let sections = [
			{
				header    : t.profiles.init,
				id        : "pauMenuPerfiles",
				icon      : pictos.perfiles.principal,
				onClick   : eventClickPauActions,
				showArrow : false,
				items     : [
					{
						group : [
							{
								title    : t.profiles.default,
								id       : "pauPerfilPorDefecto",
								key      : "default",
								icon     : pictos.perfiles.porDefecto,
								classes  : "pauNot",
								value    : settings.perfil_defecto.value || false,
								show     : shows.perfil_defecto.show || false,
								callback : ( checked ) => {

									// this.callbackUniqueValue( checked, "por-defecto", this.elementsUnique.perfiles, "perfil_defecto" )

									let valCheck    = "default",
										{ cookies } = this.props,
										new_value   = {},
										setti       = cookies.get( "settings" );

									if ( checked ) {

										cookies.remove( "profileDefault", { path : "/" } );
										cookies.set( "profileDefault", valCheck, { path : "/" } );

										switch ( setti.perfil_defecto.value ) {

											case "visual-diversity" :
												$( "#pauPerilfDivVisual" ).trigger( "click" );
												break;

											case "auditive-diversity" :
												$( "#pauPerilfDivAudi" ).trigger( "click" );
												break;

											case "cognitive-diversity" :
												$( "#pauPerilfDivCogni" ).trigger( "click" );
												break;

											case "custom" :
												$( "#pauPerilfPer" ).trigger( "click" );
												break;

										}

										valCheck = "default";

										ProfilesActions.selection( valCheck );

										new_value[ "perfil_defecto" ] = {
											value : { $set : valCheck }
										};

										setti = cookies.get( "settings" );

										cookies.remove( "settings", { path : "/" } );
										cookies.set( "settings", update( setti, new_value ), { path : "/" } );

										this.setState( update( this.state, {
											settings : new_value
										} ) );

									} else {

										new_value[ "perfil_defecto" ] = {
											value : { $set : '' }
										};

										setti = cookies.get( "settings" );

										cookies.remove( "settings", { path : "/" } );
										cookies.set( "settings", update( setti, new_value ), { path : "/" } );

										this.setState( update( this.state, {
											settings : new_value
										} ) );

									}

								}
							},
							{
								title    : t.profiles.visualDiversity,
								id       : "pauPerilfDivVisual",
								key      : "visual-diversity",
								icon     : pictos.perfiles.visual,
								classes  : "pauNot",
								value    : settings.perfil_defecto.value || false,
								show     : shows.perfil_defecto.show || false,
								callback : ( checked ) => {

									// this.callbackUniqueValue( checked, "diversidad-visual", this.elementsUnique.perfiles, "perfil_defecto" )

									let valCheck    = "visual-diversity",
										{ cookies } = this.props,
										new_value   = {},
										setti       = cookies.get( "settings" );

									if ( checked ) {

										cookies.remove( "profileDefault", { path : "/" } );
										cookies.set( "profileDefault", valCheck, { path : "/" } );

										switch ( setti.perfil_defecto.value ) {

											case "default" :
												$( "#pauPerfilPorDefecto" ).trigger( "click" );
												break;

											case "auditive-diversity" :
												$( "#pauPerilfDivAudi" ).trigger( "click" );
												break;

											case "cognitive-diversity" :
												$( "#pauPerilfDivCogni" ).trigger( "click" );
												break;

											case "custom" :
												$( "#pauPerilfPer" ).trigger( "click" );
												break;

										}

										// valCheck = "visual-diversity";

										ProfilesActions.selection( valCheck );

										new_value[ "perfil_defecto" ] = {
											value : { $set : valCheck }
										};

										setti = cookies.get( "settings" );

										cookies.remove( "settings", { path : "/" } );
										cookies.set( "settings", update( setti, new_value ), { path : "/" } );

										this.setState( update( this.state, {
											settings : new_value
										} ) );

									} else {

										let profileDefault = cookies.get( "profileDefault" );

										if ( profileDefault === valCheck ) {
											$( "#pauPerfilPorDefecto" ).trigger( "click" );
										}

									}

								}

							},
							{
								title    : t.profiles.auditiveDiversity,
								id       : "pauPerilfDivAudi",
								key      : "auditive-diversity",
								icon     : pictos.perfiles.auditivo,
								classes  : "pauNot",
								value    : settings.perfil_defecto.value || false,
								show     : shows.perfil_defecto.show || false,
								callback : ( checked ) => {

									// this.callbackUniqueValue( checked, "diversidad-auditiva", this.elementsUnique.perfiles, "perfil_defecto" )

									let valCheck    = "auditive-diversity",
										{ cookies } = this.props,
										new_value   = {},
										setti       = cookies.get( "settings" );

									if ( checked ) {

										cookies.remove( "profileDefault", { path : "/" } );
										cookies.set( "profileDefault", valCheck, { path : "/" } );

										switch ( setti.perfil_defecto.value ) {

											case "default" :
												$( "#pauPerfilPorDefecto" ).trigger( "click" );
												break;

											case "visual-diversity" :
												$( "#pauPerilfDivVisual" ).trigger( "click" );
												break;

											case "cognitive-diversity" :
												$( "#pauPerilfDivCogni" ).trigger( "click" );
												break;

											case "custom" :
												$( "#pauPerilfPer" ).trigger( "click" );
												break;

										}

										// valCheck = "auditive-diversity";

										ProfilesActions.selection( valCheck );

										new_value[ "perfil_defecto" ] = {
											value : { $set : valCheck }
										};

										setti = cookies.get( "settings" );

										cookies.remove( "settings", { path : "/" } );
										cookies.set( "settings", update( setti, new_value ), { path : "/" } );

										this.setState( update( this.state, {
											settings : new_value
										} ) );

									} else {

										let profileDefault = cookies.get( "profileDefault" );

										if ( profileDefault === valCheck ) {
											$( "#pauPerfilPorDefecto" ).trigger( "click" );
										}

									}

								}
							},
							{
								title    : t.profiles.cognitiveDiversity,
								id       : "pauPerilfDivCogni",
								key      : "congnitive-diversity",
								icon     : pictos.perfiles.cognitiva,
								classes  : "pauNot",
								value    : settings.perfil_defecto.value || false,
								show     : shows.perfil_defecto.show || false,
								callback : ( checked ) => {

									// this.callbackUniqueValue( checked, "diversidad-cognitiva", this.elementsUnique.perfiles, "perfil_defecto" )

									let valCheck    = "cognitive-diversity",
										{ cookies } = this.props,
										new_value   = {},
										setti       = cookies.get( "settings" );

									if ( checked ) {

										cookies.remove( "profileDefault", { path : "/" } );
										cookies.set( "profileDefault", valCheck, { path : "/" } );

										switch ( setti.perfil_defecto.value ) {

											case "default" :
												$( "#pauPerfilPorDefecto" ).trigger( "click" );
												break;

											case "visual-diversity" :
												$( "#pauPerilfDivVisual" ).trigger( "click" );
												break;

											case "auditive-diversity" :
												$( "#pauPerilfDivAudi" ).trigger( "click" );
												break;

											case "custom" :
												$( "#pauPerilfPer" ).trigger( "click" );
												break;

										}

										// valCheck = "cognitive-diversity";

										// if( setti.perfil_defecto.value !== valCheck ) {

										ProfilesActions.selection( valCheck );

										new_value[ "perfil_defecto" ] = {
											value : { $set : valCheck }
										};

										setti = cookies.get( "settings" );

										cookies.remove( "settings", { path : "/" } );
										cookies.set( "settings", update( setti, new_value ), { path : "/" } );

										this.setState( update( this.state, {
											settings : new_value
										} ) );

										// }

									} else {

										let profileDefault = cookies.get( "profileDefault" );

										if ( profileDefault === valCheck ) {
											$( "#pauPerfilPorDefecto" ).trigger( "click" );
										}

									}

								}
							},
							{
								title    : t.profiles.custom,
								id       : "pauPerilfPer",
								key      : "custom",
								icon     : pictos.perfiles.personalizado,
								classes  : "pauNot",
								value    : settings.perfil_defecto.value || false,
								show     : shows.perfil_defecto.show || false,
								callback : ( checked ) => {

									// this.callbackUniqueValue( checked, "personalizado", this.elementsUnique.perfiles, "perfil_defecto" )

									let valCheck    = "custom",
										{ cookies } = this.props,
										new_value   = {},
										setti       = cookies.get( "settings" );

									if ( checked ) {

										cookies.remove( "profileDefault", { path : "/" } );
										cookies.set( "profileDefault", valCheck, { path : "/" } );

										switch ( setti.perfil_defecto.value ) {

											case "default" :
												$( "#pauPerfilPorDefecto" ).trigger( "click" );
												break;

											case "visual-diversity" :
												$( "#pauPerilfDivVisual" ).trigger( "click" );
												break;

											case "auditive-diversity" :
												$( "#pauPerilfDivAudi" ).trigger( "click" );
												break;

											case "cognitive-diversity" :
												$( "#pauPerilfDivCogni" ).trigger( "click" );
												break;

										}

										// valCheck = "custom";

										ProfilesActions.selection( valCheck );

										new_value[ "perfil_defecto" ] = {
											value : { $set : valCheck }
										};

										setti = cookies.get( "settings" );

										cookies.remove( "settings", { path : "/" } );
										cookies.set( "settings", update( setti, new_value ), { path : "/" } );

										this.setState( update( this.state, {
											settings : new_value
										} ) );

									} else {

										let profileDefault = cookies.get( "profileDefault" );

										if ( profileDefault === valCheck ) {
											$( "#pauPerfilPorDefecto" ).trigger( "click" );
										}

									}

								}

							}
						]
					}
				]
			},

			{
				header    : t.general.init,
				id        : "pauMenuGeneral",
				icon      : pictos.general.principal,
				onClick   : eventClickPauActions,
				showArrow : false,
				items     : [
					{
						title    : t.general.showHideAll,
						id       : "pau_react_geral_todo",
						classes  : "pauNot",
						icon     : pictos.general.todo,
						value    : settings.geral_todo.value,
						show     : shows.geral_todo.show,
						type     : "switch",
						callback : ( checked ) => {

							let { cookies }   = this.props,
								setti         = cookies.get( "settings" ),
								font_size_val = 1;

							if ( checked ) {

								if ( !setti.geral_video.value ) {
									$( "#pau_react_geral_video" ).trigger( "click" );
								}

								if ( !setti.geral_sonido.value ) {
									$( "#pau_react_geral_sonido" ).trigger( "click" );
								}

								if ( !setti.geral_lectura.value ) {
									$( "#pau_react_geral_lectura" ).trigger( "click" );
								}

								if ( setti.geral_video.value ) {
									$( "#pau_react_geral_video" ).trigger( "click" );
								}

								if ( setti.geral_sonido.value ) {
									$( "#pau_react_geral_sonido" ).trigger( "click" );
								}

								if ( setti.geral_lectura.value ) {
									$( "#pau_react_geral_lectura" ).trigger( "click" );
								}

								/**
								 * Se agrega script para ocultar todo
								 */

								if ( !setti.nav_bigcursor.value ) {
									$( "#pau_react_nav_bigcursor" ).trigger( "click" );
								}

								if ( !setti.nav_clic.value ) {
									$( "#pau_react_nav_clic" ).trigger( "click" );
								}

								if ( !setti.nav_donde.value ) {
									$( "#pau_react_nav_donde" ).trigger( "click" );
								}

								// if( ! setti.nav_zoom.value ) {
								//     $( "#pau_react_nav_zoom" ).trigger( "click" );
								// }

								if ( setti.font_size.value !== 1 ) {

									let $selcFontSize = $( "#pau_react_font_size" ).get( 0 );

									$selcFontSize.value = 1;

									ReactTestUtils.Simulate.change( $selcFontSize );
									ReactTestUtils.Simulate.focus( $selcFontSize );

								}

								// if( setti.font_dislexia_legible.value !== "readable" ) {
								//     $( "#pauFuentesLegible" ).trigger( "click" );
								// }

								if ( !setti.font_resaltar_links.value ) {
									$( "#pau_react_resaltar_links" ).trigger( "click" );
								}

								if ( !setti.visual_resaltar_focus.value ) {
									$( "#pau_react_resaltar_focus" ).trigger( "click" );
								}

							} else {

								if ( setti.geral_video.value ) {
									$( "#pau_react_geral_video" ).trigger( "click" );
								}

								if ( setti.geral_sonido.value ) {
									$( "#pau_react_geral_sonido" ).trigger( "click" );
								}

								if ( setti.geral_lectura.value ) {
									$( "#pau_react_geral_lectura" ).trigger( "click" );
								}

								/**
								 * Se agrega script para ocultar todo
								 */

								if ( setti.nav_bigcursor.value ) {
									$( "#pau_react_nav_bigcursor" ).trigger( "click" );
								}

								if ( setti.nav_clic.value ) {
									$( "#pau_react_nav_clic" ).trigger( "click" );
								}

								if ( setti.nav_donde.value ) {
									$( "#pau_react_nav_donde" ).trigger( "click" );
								}

								if ( setti.nav_zoom.value ) {
									$( "#pau_react_nav_zoom" ).trigger( "click" );
								}

								if ( setti.font_dislexia_legible.value === "readable" ) {
									$( "#pauFuentesLegible" ).trigger( "click" );
								}

								if ( setti.font_dislexia_legible.value === "dyslexia" ) {
									$( "#pauFuentesDislexia" ).trigger( "click" );
								}

								if ( setti.font_resaltar_links.value ) {
									$( "#pau_react_resaltar_links" ).trigger( "click" );
								}

								if ( setti.visual_colors.value === "blackwhite" ) {
									$( "#pau_react_blanco_negro" ).trigger( "click" );
								}

								if ( setti.visual_colors.value === "invert-colors" ) {
									$( "#pau_react_invertir_colores" ).trigger( "click" );
								}

								if ( setti.visual_resaltar_focus.value ) {
									$( "#pau_react_resaltar_focus" ).trigger( "click" );
								}

								if ( setti.font_size.value !== 1 ) {

									let $selcFontSize = $( "#pau_react_font_size" ).get( 0 );

									$selcFontSize.value = 1;

									ReactTestUtils.Simulate.change( $selcFontSize );
									ReactTestUtils.Simulate.focus( $selcFontSize );

								}

								font_size_val = 1;

							}

							let geral_todo            = {
									value : { $set : checked }
								},
								geral_video           = {
									value : { $set : checked }
								},
								geral_sonido          = {
									value : { $set : checked }
								},
								geral_lectura         = {
									value : { $set : checked }
								},
								nav_bigcursor         = {
									value : { $set : checked }
								},
								nav_clic              = {
									value : { $set : checked }
								},
								nav_donde             = {
									value : { $set : checked }
								},
								nav_zoom              = {
									value : { $set : checked }
								},
								font_size             = {
									value : { $set : font_size_val }
								},
								font_dislexia_legible = {
									value : { $set : checked }
								},
								font_resaltar_links   = {
									value : { $set : checked }
								},
								visual_colors         = {
									value : { $set : checked }
								},
								visual_resaltar_focus = {
									value : { $set : checked }
								};

							// AccesibilityActions.tamanioFuente( value );
							cookies.remove( "settings", { path : "/" } );
							cookies.set( "settings", update( setti, {
								geral_todo,
								geral_video,
								geral_sonido,
								geral_lectura,
								nav_bigcursor,
								nav_clic,
								nav_donde,
								nav_zoom,
								font_dislexia_legible,
								font_size,
								font_resaltar_links,
								visual_colors,
								visual_resaltar_focus
							} ), { path : "/" } );

							this.setState( update( this.state, {
								settings : {
									geral_todo,
									geral_video,
									geral_sonido,
									geral_lectura,
									nav_bigcursor,
									nav_clic,
									nav_donde,
									nav_zoom,
									font_dislexia_legible,
									font_size,
									font_resaltar_links,
									visual_colors,
									visual_resaltar_focus
								}
							} ) );

							let noPersonalizado = parseInt( cookies.get( "noPersonalizado" ), 10 );

							if ( !noPersonalizado && setti.perfil_defecto.value !== "custom" ) {

								let $profileCustom = d.getElementById( "pauPerilfPer" );

								ReactTestUtils.Simulate.click( $profileCustom );

							}

						}
					},
					{
						title    : t.general.activateGeralSound,
						id       : "pau_react_geral_sonido",
						classes  : "pauNot",
						icon     : pictos.general.sonido,
						value    : settings.geral_sonido.value,
						show     : shows.geral_sonido.show,
						type     : "switch",
						callback : ( checked ) => {

							let { cookies } = this.props,
								setti       = cookies.get( "settings" );

							let geral_sonido = {
								value : { $set : checked }
							};

							cookies.remove( "settings", { path : "/" } );
							cookies.set( "settings", update( setti, {
								geral_sonido
							} ), { path : "/" } );

							this.setState( update( this.state, {
								settings : {
									geral_sonido
								}
							} ) );

							let noPersonalizado = parseInt( cookies.get( "noPersonalizado" ), 10 );

							if ( !noPersonalizado && setti.perfil_defecto.value !== "custom" ) {

								let $profileCustom = d.getElementById( "pauPerilfPer" );

								ReactTestUtils.Simulate.click( $profileCustom );

							}

						}
					},
					{
						title    : t.general.allLSEVideos,
						id       : "pau_react_geral_video",
						classes  : "pauNot",
						icon     : pictos.general.video,
						value    : settings.geral_video.value,
						show     : shows.geral_video.show,
						type     : "switch",
						callback : ( checked ) => {

							let { cookies } = this.props,
								setti       = cookies.get( "settings" );

							let geral_video = {
								value : { $set : checked }
							};

							cookies.remove( "settings", { path : "/" } );
							cookies.set( "settings", update( setti, {
								geral_video
							} ), { path : "/" } );

							this.setState( update( this.state, {
								settings : {
									geral_video
								}
							} ) );

							let noPersonalizado = parseInt( cookies.get( "noPersonalizado" ), 10 );

							if ( !noPersonalizado && setti.perfil_defecto.value !== "custom" ) {

								let $profileCustom = d.getElementById( "pauPerilfPer" );

								ReactTestUtils.Simulate.click( $profileCustom );

							}

						}
					},
					{
						title    : t.general.readingSoundContent,
						id       : "pau_react_geral_lectura",
						classes  : "pauNot",
						icon     : pictos.general.lectura,
						value    : settings.geral_lectura.value,
						show     : shows.geral_lectura.show,
						type     : "switch",
						callback : ( checked ) => {

							let { cookies } = this.props,
								setti       = cookies.get( "settings" );

							let geral_lectura = {
								value : { $set : checked }
							};

							cookies.remove( "settings", { path : "/" } );
							cookies.set( "settings", update( setti, {
								geral_lectura
							} ), { path : "/" } );

							this.setState( update( this.state, {
								settings : {
									geral_lectura
								}
							} ) );

							let noPersonalizado = parseInt( cookies.get( "noPersonalizado" ), 10 );

							if ( !noPersonalizado && setti.perfil_defecto.value !== "custom" ) {

								let $profileCustom = d.getElementById( "pauPerilfPer" );

								ReactTestUtils.Simulate.click( $profileCustom );

							}

						}
					}
				]
			},

			{
				header    : t.navigation.init,
				id        : "pauMenuNavegacion",
				icon      : pictos.navegacion.principal,
				onClick   : eventClickPauActions,
				showArrow : false,
				items     : [
					{
						title    : t.navigation.largeCursor,
						id       : "pau_react_nav_bigcursor",
						classes  : "pauNot",
						icon     : pictos.navegacion.bigcursor,
						value    : settings.nav_bigcursor.value,
						show     : shows.nav_bigcursor.show,
						type     : "switch",
						callback : ( checked ) => {

							AccesibilityActions.bigcursor( checked );

							let { cookies } = this.props,
								setti       = cookies.get( "settings" );

							let nav_bigcursor = {
								value : { $set : checked }
							};

							cookies.remove( "settings", { path : "/" } );
							cookies.set( "settings", update( setti, {
								nav_bigcursor
							} ), { path : "/" } );

							this.setState( update( this.state, {
								settings : {
									nav_bigcursor
								}
							} ) );

							let noPersonalizado = parseInt( cookies.get( "noPersonalizado" ), 10 );

							if ( !noPersonalizado && setti.perfil_defecto.value !== "custom" ) {

								let $profileCustom = d.getElementById( "pauPerilfPer" );

								ReactTestUtils.Simulate.click( $profileCustom );

							}

						}
					},
					{
						title    : t.navigation.clickSound,
						id       : "pau_react_nav_clic",
						classes  : "pauNot",
						icon     : pictos.navegacion.nav,
						value    : settings.nav_clic.value,
						show     : shows.nav_clic.show,
						type     : "switch",
						callback : ( checked ) => {

							let { cookies } = this.props,
								setti       = cookies.get( "settings" );

							let nav_clic = {
								value : { $set : checked }
							};

							cookies.remove( "settings", { path : "/" } );
							cookies.set( "settings", update( setti, {
								nav_clic
							} ), { path : "/" } );

							this.setState( update( this.state, {
								settings : {
									nav_clic
								}
							} ) );

							let noPersonalizado = parseInt( cookies.get( "noPersonalizado" ), 10 );

							if ( !noPersonalizado && setti.perfil_defecto.value !== "custom" ) {

								let $profileCustom = d.getElementById( "pauPerilfPer" );

								ReactTestUtils.Simulate.click( $profileCustom );

							}

						}
					},
					{
						title    : t.navigation.showWhere,
						id       : "pau_react_nav_donde",
						classes  : "pauNot",
						icon     : pictos.navegacion.donde,
						value    : settings.nav_donde.value,
						show     : shows.nav_donde.show,
						type     : "switch",
						callback : ( checked ) => {

							AccesibilityActions.donde( checked );

							let { cookies } = this.props,
								setti       = cookies.get( "settings" );

							let nav_donde = {
								value : { $set : checked }
							};

							cookies.remove( "settings", { path : "/" } );
							cookies.set( "settings", update( setti, {
								nav_donde
							} ), { path : "/" } );

							this.setState( update( this.state, {
								settings : {
									nav_donde
								}
							} ) );

							let noPersonalizado = parseInt( cookies.get( "noPersonalizado" ), 10 );

							if ( !noPersonalizado && setti.perfil_defecto.value !== "custom" ) {

								let $profileCustom = d.getElementById( "pauPerilfPer" );

								ReactTestUtils.Simulate.click( $profileCustom );

							}

						}
					},
					{
						title    : t.navigation.zoomLinks,
						id       : "pau_react_nav_zoom",
						classes  : "pauNot",
						icon     : pictos.navegacion.zoom,
						value    : settings.nav_zoom.value,
						show     : shows.nav_zoom.show,
						type     : "switch",
						callback : ( checked ) => {

							AccesibilityActions.zoomLink( checked );

							let { cookies } = this.props,
								setti       = cookies.get( "settings" );

							let nav_zoom = {
								value : { $set : checked }
							};

							cookies.remove( "settings", { path : "/" } );
							cookies.set( "settings", update( setti, {
								nav_zoom
							} ), { path : "/" } );

							this.setState( update( this.state, {
								settings : {
									nav_zoom
								}
							} ) );

							let noPersonalizado = parseInt( cookies.get( "noPersonalizado" ), 10 );

							if ( !noPersonalizado && setti.perfil_defecto.value !== "custom" ) {

								let $profileCustom = d.getElementById( "pauPerilfPer" );

								ReactTestUtils.Simulate.click( $profileCustom );

							}

						}
					},
				]
			},

			{
				header    : t.fonts.init,
				id        : "pauMenuFuentes",
				icon      : pictos.fuentes.principal,
				onClick   : eventClickPauActions,
				showArrow : false,
				items     : [
					{
						title    : t.fonts.fontSize,
						id       : "pau_react_font_size",
						classes  : "pauNot",
						icon     : pictos.fuentes.tamanio,
						value    : settings.font_size.value,
						show     : shows.font_size.show,
						type     : "number",
						min      : 1,
						max      : 9,
						callback : ( value ) => {

							let { cookies } = this.props,
								setti       = cookies.get( "settings" );

							let font_size = {
								value : { $set : value }
							};

							AccesibilityActions.tamanioFuente( value );

							cookies.remove( "settings", { path : "/" } );
							cookies.set( "settings", update( setti, {
								font_size
							} ), { path : "/" } );

							this.setState( update( this.state, {
								settings : {
									font_size
								}
							} ) );

							let noPersonalizado = parseInt( cookies.get( "noPersonalizado" ), 10 );

							if ( !noPersonalizado && setti.perfil_defecto.value !== "custom" ) {

								let $profileCustom = d.getElementById( "pauPerilfPer" );

								ReactTestUtils.Simulate.click( $profileCustom );

							}

						}
					},
					{
						group : [
							{
								title    : t.fonts.readable,
								id       : "pauFuentesLegible",
								key      : "readable",
								classes  : "pauNot",
								icon     : pictos.fuentes.legible,
								value    : settings.font_dislexia_legible.value || false,
								show     : shows.font_legible.show,
								type     : "switch",
								callback : ( checked ) => {

									// this.callbackUniqueValue( checked, "legible", this.elementsUnique.fuentes, "font_dislexia_legible" )

									let valCheck    = "",
										{ cookies } = this.props,
										setti       = cookies.get( "settings" );

									AccesibilityActions.fuentes( "readable", checked );

									if ( checked ) {

										if ( setti.font_dislexia_legible.value === "dyslexia" ) {
											ReactTestUtils.Simulate.click( d.getElementById( "pauFuentesDislexia" ) );
										}

										valCheck = "readable";

									}

									let font_dislexia_legible = {
										value : { $set : valCheck }
									};

									cookies.remove( "settings", { path : "/" } );
									cookies.set( "settings", update( setti, {
										font_dislexia_legible
									} ), { path : "/" } );

									this.setState( update( this.state, {
										settings : {
											font_dislexia_legible
										}
									} ) );

									let noPersonalizado = parseInt( cookies.get( "noPersonalizado" ), 10 );

									if ( !noPersonalizado && setti.perfil_defecto.value !== "custom" ) {

										let $profileCustom = d.getElementById( "pauPerilfPer" );

										ReactTestUtils.Simulate.click( $profileCustom );

									}

								}
							},
							{
								title    : t.fonts.dyslexia,
								id       : "pauFuentesDislexia",
								key      : "dyslexia",
								classes  : "pauNot",
								icon     : pictos.fuentes.dislexia,
								value    : settings.font_dislexia_legible.value || false,
								show     : shows.font_dislexia.show,
								type     : "switch",
								callback : ( checked ) => {

									// this.callbackUniqueValue( checked, "dislexia", this.elementsUnique.fuentes, "font_dislexia_legible" )

									let valCheck    = "",
										{ cookies } = this.props,
										setti       = cookies.get( "settings" );

									AccesibilityActions.fuentes( "dyslexia", checked );

									if ( checked ) {

										if ( setti.font_dislexia_legible.value === "readable" ) {
											ReactTestUtils.Simulate.click( d.getElementById( "pauFuentesLegible" ) );
										}

										valCheck = "dyslexia";

									}

									let font_dislexia_legible = {
										value : { $set : valCheck }
									};

									cookies.remove( "settings", { path : "/" } );
									cookies.set( "settings", update( setti, {
										font_dislexia_legible
									} ), { path : "/" } );

									this.setState( update( this.state, {
										settings : {
											font_dislexia_legible
										}
									} ) );

									let noPersonalizado = parseInt( cookies.get( "noPersonalizado" ), 10 );

									if ( !noPersonalizado && setti.perfil_defecto.value !== "custom" ) {

										let $profileCustom = d.getElementById( "pauPerilfPer" );

										ReactTestUtils.Simulate.click( $profileCustom );

									}

								}
							}
						]
					},
					{
						title    : t.fonts.highlightLinks,
						id       : "pau_react_resaltar_links",
						classes  : "pauNot",
						icon     : pictos.fuentes.enlaces,
						value    : settings.font_resaltar_links.value,
						show     : shows.font_resaltar_links.show,
						type     : "switch",
						callback : ( checked ) => {

							let { cookies } = this.props,
								setti       = cookies.get( "settings" );

							let font_resaltar_links = {
								value : { $set : checked }
							};

							AccesibilityActions.resaltarEnlaces( checked );

							cookies.remove( "settings", { path : "/" } );
							cookies.set( "settings", update( setti, {
								font_resaltar_links
							} ), { path : "/" } );

							this.setState( update( this.state, {
								settings : {
									font_resaltar_links
								}
							} ) );

							let noPersonalizado = parseInt( cookies.get( "noPersonalizado" ), 10 );

							if ( !noPersonalizado && setti.perfil_defecto.value !== "custom" ) {

								let $profileCustom = d.getElementById( "pauPerilfPer" );

								ReactTestUtils.Simulate.click( $profileCustom );

							}

						}
					}
				]
			},

			{
				header    : t.visual.init,
				id        : "pauMenuVisual",
				icon      : pictos.visual.principal,
				onClick   : eventClickPauActions,
				showArrow : false,
				items     : [
					{
						group : [
							{
								title    : t.visual.blackWhite,
								id       : "pau_react_blanco_negro",
								key      : "blackwhite",
								classes  : "pauNot",
								icon     : pictos.visual.blancoNegro,
								value    : settings.visual_colors.value,
								show     : shows.visual_colors_bn.show,
								callback : ( checked ) => {

									// this.callbackUniqueValue( checked, "blanconegro", this.elementsUnique.visuals, "visual_colors" )
									let valCheck    = "",
										{ cookies } = this.props,
										setti       = cookies.get( "settings" );

									AccesibilityActions.visual( "blackwhite", checked );

									if ( checked ) {

										if ( setti.visual_colors.value === "invert-colors" ) {
											ReactTestUtils.Simulate.click( d.getElementById( "pau_react_invertir_colores" ) );
										}

										valCheck = "blackwhite";

									}

									let visual_colors = {
										value : { $set : valCheck }
									};

									cookies.remove( "settings", { path : "/" } );
									cookies.set( "settings", update( setti, {
										visual_colors
									} ), { path : "/" } );

									this.setState( update( this.state, {
										settings : {
											visual_colors
										}
									} ) );

									let noPersonalizado = parseInt( cookies.get( "noPersonalizado" ), 10 );

									if ( !noPersonalizado && setti.perfil_defecto.value !== "custom" ) {

										let $profileCustom = d.getElementById( "pauPerilfPer" );

										ReactTestUtils.Simulate.click( $profileCustom );

									}

								}
							},
							{
								title    : t.visual.invertColors,
								id       : "pau_react_invertir_colores",
								key      : "invert-colors",
								classes  : "pauNot",
								icon     : pictos.visual.invertirColores,
								value    : settings.visual_colors.value,
								show     : shows.visual_colors_invert.show,
								callback : ( checked ) => {

									// this.callbackUniqueValue( checked, "invertir-colores", this.elementsUnique.visuals, "visual_colors" )
									// debugger;
									let valCheck    = "",
										{ cookies } = this.props,
										setti       = cookies.get( "settings" );

									AccesibilityActions.visual( "invert-colors", checked );

									if ( checked ) {

										if ( setti.visual_colors.value === "blackwhite" ) {
											ReactTestUtils.Simulate.click( d.getElementById( "pau_react_blanco_negro" ) );
										}

										valCheck = "invert-colors";

									}

									let visual_colors = {
										value : { $set : valCheck }
									};

									cookies.remove( "settings", { path : "/" } );
									cookies.set( "settings", update( setti, {
										visual_colors
									} ), { path : "/" } );

									this.setState( update( this.state, {
										settings : {
											visual_colors
										}
									} ) );

									let noPersonalizado = parseInt( cookies.get( "noPersonalizado" ), 10 );

									if ( !noPersonalizado && setti.perfil_defecto.value !== "custom" ) {

										let $profileCustom = d.getElementById( "pauPerilfPer" );

										ReactTestUtils.Simulate.click( $profileCustom );

									}

								}
							}
						]
					},
					{
						title    : t.visual.selectionFocus,
						id       : "pau_react_resaltar_focus",
						classes  : "pauNot",
						icon     : pictos.fuentes.enlaces,
						value    : settings.visual_resaltar_focus.value,
						show     : shows.visual_resaltar_focus.show,
						type     : "switch",
						callback : ( checked ) => {

							let { cookies } = this.props,
								setti       = cookies.get( "settings" );

							let visual_resaltar_focus = {
								value : { $set : checked }
							};

							AccesibilityActions.focus( checked );

							cookies.remove( "settings", { path : "/" } );
							cookies.set( "settings", update( setti, {
								visual_resaltar_focus
							} ), { path : "/" } );

							this.setState( update( this.state, {
								settings : {
									visual_resaltar_focus
								}
							} ) );

							let noPersonalizado = parseInt( cookies.get( "noPersonalizado" ), 10 );

							if ( !noPersonalizado && setti.perfil_defecto.value !== "custom" ) {

								let $profileCustom = d.getElementById( "pauPerilfPer" );

								ReactTestUtils.Simulate.click( $profileCustom );

							}

						}
					}
				]
			},

			{
				header    : t.design.init,
				id        : "pauMenuDiseno",
				icon      : pictos.diseno.principal,
				onClick   : eventClickPauActions,
				showArrow : false,
				items     : [
					{
						title   : t.design.increasePanel,
						id      : "pau_react_dis_aumento",
						classes : "pauNot",
						icon    : pictos.diseno.plantilla,
						show    : true,
						type    : "zoomPau"
					},
					{
						title   : t.design.selPAUDesignTemplate,
						id      : "pau_react_dis_plantilla",
						classes : "pauNot",
						icon    : pictos.diseno.plantilla,
						show    : true,
						type    : "proximamente"
					},
					{
						title   : t.design.selPositionPAU,
						id      : "pau_react_dis_position",
						classes : "pauNot",
						icon    : pictos.diseno.posicion,
						show    : true,
						type    : "proximamente"
					}
				]
			},

			{
				header    : t.help.init,
				id        : "pauMenuAyuda",
				icon      : pictos.ayuda.principal,
				onClick   : eventClickPauActions,
				showArrow : false,
				items     : [
					{
						title   : t.help.documentation,
						id      : "pau_react_ayuda_docum",
						classes : "pauNot",
						icon    : pictos.ayuda.documentacion,
						show    : true,
						type    : "link",
						link    : t.help.documentationLink
					},
					{
						title   : t.help.videos + ` ${t.others.comingSoon}`,
						id      : "pau_react_ayuda_video",
						classes : "pauNot",
						icon    : pictos.ayuda.video,
						show    : true,
						type    : "link",
						link    : ""
					},
					// {
					//     title       : t.help.support,
					//     id          : "pau_react_ayuda_soporte",
					//     classes     : "pauNot",
					//     icon        : pictos.ayuda.soporte,
					//     show        : true,
					//     type        : "link"
					// },
					{
						title   : t.help.suggestions,
						id      : "pau_react_ayuda_sug",
						classes : "pauNot",
						icon    : pictos.ayuda.sugerencias,
						show    : true,
						type    : "link",
						link    : t.help.suggestionsLink
					}
				]
			}

		];

		return sections;

	}

	strToSections = sections => {

		return sections.map( section => {

			// const id = PauHelpers.normalize( section.header ).replace( " ", "-" ).toLowerCase();

			let shows = this.validteShows( section.items );

			if ( shows ) {

				return <div
					key={section.id}
					id={section.id}>
					<h2 className="titleSectionPanel">{section.header}</h2>
					<CreateForm
						header={section.header}
						items={section.items}
						settings={this.state.settings}
						globals={this.props.globals}
					/>
				</div>;

			}

		} );

	};

	strToLi = sections => {

		return sections.map( section => {

			let shows = this.validteShows( section.items );

			if ( shows ) {

				return <li
					key={section.id}>
					<a href={`#${section.id}`}>
						<img
							alt={section.id}
							className="iconEstInc"
							src={section.icon}
							data-key="pauReactMenus"
							onClick={section.onClick}/>
					</a>
				</li>;

			}

		} );

	};

	validteShows( items ) {

		let shows = false;

		ItemInit: for ( let item of items ) {

			if ( item.hasOwnProperty( "group" ) ) {

				for ( let itemGroup of item.group ) {

					if ( itemGroup.show === "on" ) {
						shows = true;
						break ItemInit;
					}

				}

			} else {

				if ( item.show ) {
					shows = true;
					break;
				}

			}

		}

		return shows;

	}

	componentWillUpdate( prevProps, prevState ) {

		// console.log( "componentWillUpdate" );
		// console.log( prevState );

	}

	render() {

		const { settings } = this.state;

		// console.log( this.state );

		// console.log( "CreateSection -> render() -> sections.fuentes.tamaño.items.value" );
		// console.log( this.props.sections[ 3 ].items[ 0 ] );

		return <div
			className="pauAccesMenu">
			<nav
				id='pau-navigation'
				className='pau-navigation'
				role='navigation'
				aria-label='PAU'>
				<ul className="pauReactMenus">
					{this.strToLi( this.getSections( settings ) )}
				</ul>
			</nav>
			<div
				className="panelActions">
				{this.strToSections( this.getSections( settings ) )}
			</div>
		</div>;

	}

}

CreateSection.propTypes = {
	settings : PropTypes.object.isRequired,
	// sections    : PropTypes.array.isRequired
};

export default withCookies( CreateSection );



// WEBPACK FOOTER //
// ./src/includes/CreateSection.js